

















































import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import Global from '@/common/global.js'
import store from '@/store'
import PopupNotice from '@/views/template/PopupNotice.vue'
import PopupRentalContainer from '@/views/template/PopupRentalContainer.vue'
import PopupRemarks from '@/views/template/PopupRemarks.vue'
import PopupComfirmDelete from '@/views/template/PopupComfirmDelete.vue'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    ApiClient
    BlueButton
    PopupNotice
    PopupRentalContainer
    PopupRemarks
    PopupComfirmDelete
    PopupComplete
  }

  data: () ->
    tanto: []
    noticeList: {}
    isShowPopup: {}
    id: ''
    supplySourceList: Global.supplySource()
    departmentList: Global.departmentList()
    remarks1: ''
    remarks2: ''
    containerList: []
    complete: ''
    admin: store.getters.getAdminData

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    @get_tanto()

  methods: {
    click_new: (e) ->
      @$router.push 'user_edit'
    tanto_delete: () ->
      param =
        id: @id
      api = new ApiClient()
      data = await api.post('/admin/user/delete', param)
      if data.errors.length == 0
        @complete = '削除'
        @showPopup('complete')
        @get_tanto()
        @closePopup('delete')
    get_tanto: () ->
      api = new ApiClient()
      data = await api.get('/admin/user/list')
      @tanto = data.list
    detail_click: (id) ->
      @$router.push 'user_edit/detail/' + id
    noticePush: (rows) ->
      @noticeList = 
        name1: rows[0].name
        mailaddress1: rows[0].mailaddress
        extension_number1: rows[0].extension_number
        name2: rows[1].name
        mailaddress2: rows[1].mailaddress
        extension_number2: rows[1].extension_number
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    idRewrite: (id, rows) ->
      @id = id
      @containerList = rows
    goCollecSystem: (id) ->
      @$router.push 'user/system/' + id
    supplySource: (num) ->
      for row, index in @supplySourceList
        if row.id == Number(num)
          return row.name
      return ''
    remarks: (id, remarks1, remarks2) ->
      @remarks1 = remarks1
      @remarks2 = remarks2
      # @$set(@isShowPopup, property, true)
    setId: (id) ->
      @id = id
    returnDepartment: (num) ->
      for row, index in @departmentList
        if row.id == Number(num)
          return row.name
      return ''
    save: (v) ->
      api = new ApiClient()
      data = await api.post('/admin/rental/save', v)
      if data.errors.length == 0
        @complete = '変更'
        @showPopup('complete')
      @get_tanto()
      @closePopup('rentalContainer')
    clickDelete: (v) ->
      api = new ApiClient()
      data = await api.post('/admin/rental/delete', v)
      if data.errors.length == 0
        @complete = 'レンタル容器を削除'
        @showPopup('complete')
      @get_tanto()
      @closePopup('rentalContainer')
  }
